<template>
  <v-list-item-group v-if="list.length">
    <v-list-item
      v-for="(item, index) in list"
      :key="index"
      class="event-item"
      v-ripple="false"
    >
      <div class="date-container">
        <v-list-item-title class="date-content">
          <div class="day">{{ formatCustomDate(item.date).dayOfWeek }}</div>
          <div class="date">{{ formatCustomDate(item.date).dayOfMonth }}</div>
          <div class="month">{{ formatCustomDate(item.date).month }}</div>
        </v-list-item-title>
      </div>

      <v-card outlined class="event-card">
        <div v-if="filteredBirthdayEvents(item).length != 0">
          <v-card-title>
            <div style="display: flex; align-items: center">
              <v-icon style="font-size: 20px; margin: 1px 5px">mdi-cake</v-icon>
              Birthday
            </div>
          </v-card-title>
          <v-divider />
          <div class="row-container">
            <div
              v-for="(bday, index) in filteredBirthdayEvents(item)"
              :key="index"
              class="row-item"
            >
              <v-card>
                <v-card-title>{{ bday.data.fullName }}</v-card-title>
                <v-card-subtitle>{{
                  bday.data.contactTypeName
                }}</v-card-subtitle>
              </v-card>
            </div>
          </div>
        </div>

        <div>
          <v-card-title>
            <div style="display: flex; align-items: center">
              <v-icon style="font-size: 20px; margin: 1px 5px"
                >mdi-file-document</v-icon
              >
              Expiring Documents
            </div>
          </v-card-title>
          <v-divider />
          <div class="row-container">
            <div
              v-if="filteredExpiringEvents(item).length == 0"
              style="margin: 10px 25px; color: #999"
            >
              No documents to show
            </div>
            <div
              v-for="(exp, index) in filteredExpiringEvents(item)"
              :key="index"
              class="row-item"
            >
              <v-card>
                <v-card-title @click.stop="viewUser(exp)">
                  {{
                    exp.studentName !== null ? exp.studentName : exp.staffName
                  }}
                </v-card-title>
                <v-card-subtitle> </v-card-subtitle>
                <v-divider />
                <v-card-subtitle
                  >{{ exp.requirements.length }} documents expired
                  <v-icon
                    style="font-size: 20px; margin: 1px 5px"
                    @click.stop="toggleRequirements(exp)"
                    >mdi-chevron-down</v-icon
                  ></v-card-subtitle
                >
                <v-card-subtitle v-if="exp.showRequirements">
                  <div
                    v-for="(requirement, index) in exp.requirements"
                    :key="index"
                  >
                    {{ requirement }}
                  </div>
                </v-card-subtitle>
              </v-card>
            </div>
          </div>
        </div>
      </v-card>
    </v-list-item>
  </v-list-item-group>
</template>

<script>
import moment from "moment";
export default {
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
    events: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      list: [],
      daysArray: [],
      birthdayEvents: [],
      expiringEvents: [],
      showRequirements: false,
    };
  },

  watch: {
    startDate: "generateDaysArray",
    endDate: "generateDaysArray",
    events: {
      immediate: true,
      handler() {
        this.categorizeEvents();
      },
    },
  },

  computed: {},

  mounted() {
    this.generateDaysArray();
    this.fetchEvents();

    this.$nextTick(() => {
      const today = new Date();
      const formattedToday = today.toISOString().split("T")[0];
      this.highlightItemWithDate(formattedToday);
    });
  },

  methods: {
    scrollToItemWithDate(targetDate) {
      const targetIndex = this.list.findIndex(
        (item) => item.date === targetDate
      );

      if (targetIndex !== -1) {
        const listItem = this.$el.querySelector(
          `.event-item:nth-child(${targetIndex + 1})`
        );
        if (listItem) {
          listItem.scrollIntoView({ behavior: "smooth" });
        }
      }
    },

    highlightItemWithDate(targetDate) {
      const targetIndex = this.list.findIndex(
        (item) => item.date === targetDate
      );
      console.log("tarindex", targetIndex);
      const listItem = this.$el.querySelector(
        `.event-item:nth-child(${targetIndex + 1})`
      );
      if (listItem) {
        document.querySelectorAll(".event-item").forEach((item) => {
          item.querySelector(".event-card").style.borderLeft =
            "5px solid #007bff";
        });

        listItem.querySelector(".event-card").style.borderLeft =
          "5px solid gold";
      }
    },

    generateDaysArray() {
      const start = moment(this.startDate, "YYYY-MM-DD");
      const end = moment(this.endDate, "YYYY-MM-DD");

      const daysDifference = end.diff(start, "days");

      this.daysArray = Array.from(
        { length: daysDifference + 1 },
        (_, index) => {
          const currentDate = moment(start).add(index, "days");
          return currentDate.format("YYYY-MM-DD");
        }
      );
    },

    fetchEvents() {
      const filteredEvents = this.daysArray.map((date) => {
        return {
          date: date,
        };
      });

      this.list = filteredEvents;
    },

    formatCustomDate(date) {
      const momentDate = moment.utc(date);

      const dayOfWeek = momentDate.format("ddd");
      const dayOfMonth = momentDate.format("D");
      const month = momentDate.format("MMM");

      return {
        dayOfWeek,
        dayOfMonth,
        month,
      };
    },

    categorizeEvents() {
      this.birthdayEvents = [];
      this.expiringEvents = [];
      const newEvent = [];
      this.events.forEach((event) => {
        const eventDate = moment(event.start).format("YYYY-MM-DD");
        if (eventDate >= this.startDate && eventDate <= this.endDate) {
          if (event.type === "birthday") {
            this.birthdayEvents.push(event);
          } else if (event.type === "expiring") {
            // Check if there's an entry in newEvent with the same staff Id/student id and date
            const matchingEntry = newEvent.find(
              (entry) =>
                (((entry.staffId != null || entry.staffId != undefined) &&
                  entry.staffId == event.data.staffId) ||
                  (!event.data.staffId &&
                    entry.studentId == event.data.studentId)) &&
                entry.date == eventDate
            );

            // If there's a match, add the requirementName to the requirements array
            if (matchingEntry) {
              matchingEntry.requirements.push(event.data.requirementName);
            } else {
              // If no match, create a new entry in newEvent
              newEvent.push({
                staffId: event.data.staffId,
                studentId: event.data.studentId,
                staffName: event.data.staffName,
                studentName: event.data.studentName,
                certificateExpiresOn: event.data.certificateExpiresOn,
                date: eventDate,
                requirements: [event.data.requirementName],
              });
            }
          }
        }
      });
      this.expiringEvents = newEvent;
    },

    filteredBirthdayEvents(item) {
      return this.birthdayEvents.filter(
        (bday) => bday.data.dob.substr(5, 9) == item.date.substr(5, 9)
      );
    },

    filteredExpiringEvents(item) {
      console.log("expi", this.expiringEvents);
      return this.expiringEvents
        .filter((exp) => exp.date === item.date)
        .sort((a, b) => {
          const nameA = a.staffName || a.studentName || ""; 
          const nameB = b.staffName || b.studentName || ""; 

          return nameA.localeCompare(nameB);
        });
    },

    toggleRequirements(exp) {
      this.$set(exp, "showRequirements", !exp.showRequirements);
    },

    viewUser(data) {
      if (data.staffId) {
        this.$router.push({
          name: "staffView",
          params: { id: data.staffId },
        });
      } else {
        this.$router.push({
          name: "studentView",
          params: { id: data.studentId },
        });
      }
    },
  },
};
</script>

<style scoped>
.event-item {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 10px 3px;
}

.date-container {
  align-self: flex-start;
}

.date-content {
  margin: 10px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  flex: 1;
}

.date-content .day {
  color: #999;
}

.date-content .date {
  color: #000;
  font-weight: bold;
  font-size: 30px;
}

.date-content .month {
  color: #000;
  font-size: 20px;
}

.event-card {
  flex: 10;
  border-left: 5px solid #007bff;
}

.rounded-card {
  flex: 1;
  max-width: calc(33.33% - 16px);
  margin: 8px 5px;
}

.row-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
}

.row-item {
  width: 100%;
  margin: 5px;
  box-sizing: border-box;
}

@media (min-width: 600px) and (max-width: 688px) {
  .row-item {
    width: 100%;
  }
}

@media (min-width: 689px) {
  .row-item {
    width: calc(33.33% - 10px);
  }
}
</style>
